import React, { useState } from "react";
import styles from "./login.module.css";
import getStringsBasedLang from "../../strings/get_strings";
import LoginCustomInput from "./LoginCustomInput";
import CustomModal from "../../modules/cutom_modal/custom_modal";
import { DEFAULT_COLOR, EMAIL_REGEX } from "../../utils";
import { useNavigate } from "react-router-dom";
import UseErrorHandling, { showToastError, showToastSuccess } from "../../hook/UseErrorHandling";
import { createData } from "../../api/http-service";

export default function Login(props) {
  const [emailValue, setEmailValue] = useState();
  const [passValue, setPassValue] = useState();
  const [emailHelperText, setEmailHelperText] = useState("");
  const [passHelperText, setPassHelperText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPassValid, setIsPassValid] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  let navigate = useNavigate();
  const lang = localStorage.getItem("lang");
  const handleErrorApi = UseErrorHandling();

  const emailOnChangeHandler = (e) => {
    const mail = e.target.value.trim();
    if (mail.length === 0) {
      setEmailHelperText("");
      setEmailValue(null);
      setIsEmailValid(false);
    } else if (EMAIL_REGEX.test(mail)) {
      setEmailHelperText("");
      setEmailValue(mail);
      setIsEmailValid(true);
    } else {
      setEmailHelperText(getStringsBasedLang("login_emailError"));
      setIsEmailValid(false);
    }
  };

  const passOnchangeHandler = (e) => {
    const pass = e.target.value.trim();
    if (pass.length === 0) {
      setPassHelperText("");
      setPassValue(null);
      setIsPassValid(false);
    } else if (pass.length < 8) {
      setPassHelperText(getStringsBasedLang("login_passError"));
      setIsPassValid(false);
    } else {
      setPassHelperText("");
      setPassValue(pass);
      setIsPassValid(true);
    }
  };

  const loginConfirmHandler = async () => {
    if (emailValue && passValue) {
      if (isEmailValid && isPassValid) {
        setEmailHelperText("");
        setPassHelperText("");
        setIsLoading(true);
        let data = {};

        data["email"] = emailValue;
        data["password"] = passValue;
        createData("user/login", data)
          .then((loginResult) => {
            if (!loginResult?.success) {
              setIsLoading(false);
              handleErrorApi(loginResult);
              return;
            }
            localStorage.setItem("token", loginResult.data);
            createData("user/info", { token: loginResult.data })
              .then((userInfoResult) => {
                if (!userInfoResult?.success) {
                  handleErrorApi(userInfoResult);
                  setIsLoading(false);
                  return;
                }
                localStorage.setItem(
                  "info",
                  JSON.stringify(userInfoResult.data)
                );
                setIsLoading(false);
                navigate("/");
              })
              .catch((error) => {
                setIsLoading(false);
                if (error?.response) {
                  handleErrorApi(error?.response.data);
                }
              });
          })
          .catch((error) => {
            setIsLoading(false);
            if (error?.response) {
              handleErrorApi(error?.response.data);
            }
          });
      }
    } else {
      showToastError(getStringsBasedLang("login_emptyError"))
    }
  };

  const forgotPasswordClickHandler = (val) => {
    setIsModalLoading(true);
    createData("user/password/reset", {
      email: val,
    })
      .then((forgetPasswordResult) => {
        if (!forgetPasswordResult?.success) {
          handleErrorApi(forgetPasswordResult);
          setIsModalLoading(false);
          setIsOpenModal(false);
          return;
        }
        setIsOpenModal(false);
        setIsModalLoading(false);
        showToastSuccess(getStringsBasedLang("success"))

     
      })
      .catch((error) => {
        setIsModalLoading(false);
        setIsOpenModal(false);
        if (error?.response) {
          handleErrorApi(error?.response.data);
        }
      });
    
  };

  const enterKeyHadnler = (e) => {
    if (e.key === "Enter" && !isLoading) loginConfirmHandler();
  };

  return (
    <div
      className={`flex h-screen justify-center ${
        lang === "en" ? "englishIranSans" : ""
      }`}
    >
      <div className="m-auto">
        <div className="gradient_blue_background" />
        <div className="bg-white shadow-xl py-10 rounded-2xl text-center px-32 xs:px-5">
          <span className={styles.title}>
            {getStringsBasedLang("login_title")}
          </span>
          <span className={styles.subTitle}>
            {getStringsBasedLang("login_subTitle")}
          </span>
          <div
            className={`mt-10 ${lang === "en" ? "text-left" : "text-right"}`}
          >
            <div className="secondry_color mb-2">
              {getStringsBasedLang("general_email")}
            </div>
            <LoginCustomInput
              onChange={emailOnChangeHandler}
              isEmailIcon={true}
              color={!emailHelperText ? DEFAULT_COLOR : "red"}
              placeholder={getStringsBasedLang("general_email")}
              icon="email"
              enterPressed={(e) => enterKeyHadnler(e)}
            />
            <div
              className={`${
                !emailHelperText
                  ? "hidden"
                  : `block ${lang === "en" ? "text-left" : "text-right"} text-red-600`
              }`}
            >
              <span>{emailHelperText}</span>
            </div>
          </div>
          <div
            className={`mt-10 ${lang === "en" ? "text-left" : "text-right"}`}
          >
            <div className="secondry_color mb-2">
              {getStringsBasedLang("general_password")}
            </div>
            <LoginCustomInput
              onChange={passOnchangeHandler}
              isEmailIcon={false}
              color={!passHelperText ? DEFAULT_COLOR : "red"}
              placeholder={getStringsBasedLang("general_password")}
              isPassword={true}
              icon="passowrd"
              enterPressed={(e) => enterKeyHadnler(e)}
            />
            <div
              className={`${
                !passHelperText
                  ? "hidden"
                  : `block ${lang === "en" ? "text-left" : "text-right"}`
              }`}
            >
              <span>{passHelperText}</span>
            </div>
          </div>
          <div className="mt-5">
            <span
              onClick={() => setIsOpenModal(true)}
              className="secondry_color cursor-pointer mt-2"
            >
              {getStringsBasedLang("general_forgotPassword")}
            </span>
          </div>
          <div className="mt-8">
            <button
              className={`${styles.btn_login} flex items-center justify-center text-white rounded-2xl w-full py-2 cursor-pointer border-0`}
              onClick={() => !isLoading && loginConfirmHandler()}
            >
              <span>{getStringsBasedLang("login_title")}</span>
              <img
                className={`${lang === "en" ? "rotate-180 ml-2" : "mr-2"}`}
                src={require("../../assets/icons/arrow-left-line.svg").default}
                alt="Icon"
              />
            </button>
          </div>
          <div className="mt-5">
            <span className="secondry_color text-sm cursor-pointer">
              {getStringsBasedLang("login_donotAccount")}
            </span>
            <span
              onClick={() => navigate("/register")}
              className={`text-green-600 mr-2 cursor-pointer ${
                lang === "en" ? "ml-2" : ""
              }`}
            >
              {getStringsBasedLang("login_register")}
            </span>
          </div>
        </div>
        <CustomModal
          openModal={isOpenModal}
          ModalStateHandler={(value) => setIsOpenModal(value)}
          title={getStringsBasedLang("general_forgotPassword")}
          subTitle={getStringsBasedLang("general_validEmail")}
          confirmClicked={(val) => forgotPasswordClickHandler(val)}
          isModalLoading={isModalLoading}
        />
      </div>
    </div>
  );
}
